import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

// Use Vue cookie
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

// Use BootstrapVue
import { BootstrapVue } from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
Vue.use(BootstrapVue)


// Vue Select
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
Vue.component('v-select', vSelect);

// Vue google maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyA8Er0yzlfALSRtTrAUtkgGEctRvNbq4G4',
        libraries: 'places'
    }
});

// QRC Scanner / Reader
import VueQrcodeReader from 'vue-qrcode-reader';
Vue.use(VueQrcodeReader);

Vue.config.productionTip = false
Vue.prototype.$config = window.config;

// Mixins
import { data_extensions } from './extensions/extensions.data.js';
Vue.mixin(data_extensions);

import { web_extensions } from './extensions/extensions.web.js';
Vue.mixin(web_extensions);

import { orders_extensions } from './extensions/extensions.orders.js';
Vue.mixin(orders_extensions);

import { epsonClient } from '@/vendors/epson/EpsonPrinterClient.js';
Vue.mixin(epsonClient);

Vue.prototype.$showErrorToaster = (message) => {
    VueApp.$bvToast.toast(message, {
        title: 'Error',
        variant: 'danger',
        solid: true,
        autoHideDelay: 3000,
    });
}

let globalData = new Vue({
    data: {
        $isLoggedIn: localStorage.getItem('isLoggedIn') || '',
        $franchiseID: localStorage.getItem('franchiseID') || '',
        $franchiseName: localStorage.getItem('franchiseName') || '',
        $franchiseUrlFriendlyOrderName: localStorage.getItem('franchiseUrlFriendlyOrderName') || '',
        $franchiseLogoUrl: localStorage.getItem('franchiseLogoUrl') || '',
        $franchiseBannerUrl: localStorage.getItem('franchiseBannerUrl') || '',
        $franchiseAccentColor: localStorage.getItem('franchiseAccentColor') || '#000',
        $lastSessionDate: localStorage.getItem('id_token') || new Date(),
        $branchID: localStorage.getItem('branchID') || null,
        $isTab: localStorage.getItem('isTab') || false,
        $tableNo: localStorage.getItem('tableNo') || null,
        $showTopbar: true,
        $showBanner: true,
        $showBottombar: true,
        $hasItemsInCart: false,

        // SnapnPay
        $payFID: localStorage.getItem('payFID') || null,
        $payBID: localStorage.getItem('payBID') || null,
        $payInvNo: localStorage.getItem('payInvNo') || null
    }
});
Vue.mixin({
    computed: {
        $isLoggedIn: {
            get: function () { return globalData.$data.$isLoggedIn },
            set: function (value) { globalData.$data.$isLoggedIn = value; if (value != null) localStorage.setItem('isLoggedIn', value); else localStorage.removeItem('isLoggedIn'); }
        },
        $franchiseID: {
            get: function () { return globalData.$data.$franchiseID },
            set: function (value) { globalData.$data.$franchiseID = value; if (value != null) localStorage.setItem('franchiseID', value); else localStorage.removeItem('franchiseID'); }
        },
        $franchiseName: {
            get: function () { return globalData.$data.$franchiseName },
            set: function (value) { globalData.$data.$franchiseName = value; if (value != null) localStorage.setItem('franchiseName', value); else localStorage.removeItem('franchiseName'); }
        },
        $franchiseUrlFriendlyOrderName: {
            get: function () { return globalData.$data.$franchiseUrlFriendlyOrderName },
            set: function (value) { globalData.$data.$franchiseUrlFriendlyOrderName = value; if (value != null) localStorage.setItem('franchiseUrlFriendlyOrderName', value); else localStorage.removeItem('franchiseUrlFriendlyOrderName'); }
        },
        $franchiseLogoUrl: {
            get: function () { return globalData.$data.$franchiseLogoUrl },
            set: function (value) { globalData.$data.$franchiseLogoUrl = value; if (value != null) localStorage.setItem('franchiseLogoUrl', value); else localStorage.removeItem('franchiseLogoUrl'); }
        },
        $franchiseBannerUrl: {
            get: function () { return globalData.$data.$franchiseBannerUrl },
            set: function (value) { globalData.$data.$franchiseBannerUrl = value; if (value != null) localStorage.setItem('franchiseBannerUrl', value); else localStorage.removeItem('franchiseBannerUrl'); }
        },
        $franchiseAccentColor: {
            get: function () { return globalData.$data.$franchiseAccentColor },
            set: function (value) { globalData.$data.$franchiseAccentColor = value; if (value != null) localStorage.setItem('franchiseAccentColor', value); else localStorage.removeItem('franchiseAccentColor'); }
        },
        $lastSessionDate: {
            get: function () { return globalData.$data.$lastSessionDate },
            set: function (value) { globalData.$data.$lastSessionDate = value; if (value != null) localStorage.setItem('lastSessionDate', value); else localStorage.removeItem('lastSessionDate'); }
        },
        $branchID: {
            get: function () { return globalData.$data.$branchID },
            set: function (value) { globalData.$data.$branchID = value; if (value != null) localStorage.setItem('branchID', value); else localStorage.removeItem('branchID'); }
        },
        $isTab: {
            get: function () { return globalData.$data.$isTab },
            set: function (value) { globalData.$data.$isTab = value; if (value != null) localStorage.setItem('isTab', value); else localStorage.removeItem('isTab'); }
        },
        $tableNo: {
            get: function () { return globalData.$data.$tableNo },
            set: function (value) { globalData.$data.$tableNo = value; if (value != null) localStorage.setItem('tableNo', value); else localStorage.removeItem('tableNo'); }
        },
        $showTopbar: {
            get: function () { return globalData.$data.$showTopbar },
            set: function (value) { globalData.$data.$showTopbar = value; if (value != null) localStorage.setItem('showTopbar', value); else localStorage.removeItem('showTopbar'); }
        },
        $showBanner: {
            get: function () { return globalData.$data.$showBanner },
            set: function (value) { globalData.$data.$showBanner = value; if (value != null) localStorage.setItem('showBanner', value); else localStorage.removeItem('showBanner'); }
        },
        $showBottombar: {
            get: function () { return globalData.$data.$showBottombar },
            set: function (value) { globalData.$data.$showBottombar = value; if (value != null) localStorage.setItem('showBottombar', value); else localStorage.removeItem('showBottombar'); }
        },
        $hasItemsInCart: {
            get: function () { return globalData.$data.$hasItemsInCart },
            set: function (value) { globalData.$data.$hasItemsInCart = value; if (value != null) localStorage.setItem('hasItemsInCart', value); else localStorage.removeItem('hasItemsInCart'); }
        },
        $payFID: {
            get: function () { return globalData.$data.$payFID },
            set: function (value) { globalData.$data.$payFID = value; if (value != null) localStorage.setItem('payFID', value); else localStorage.removeItem('payFID'); }
        },
        $payBID: {
            get: function () { return globalData.$data.$payBID },
            set: function (value) { globalData.$data.$payBID = value; if (value != null) localStorage.setItem('payBID', value); else localStorage.removeItem('payBID'); }
        },
        $payInvNo: {
            get: function () { return globalData.$data.$payInvNo },
            set: function (value) { globalData.$data.$payInvNo = value; if (value != null) localStorage.setItem('payInvNo', value); else localStorage.removeItem('payInvNo'); }
        }
    },
    methods: {
        initOoApi: function (franchiseID) {
            Vue.prototype.$ooApi = new OnlineOrderingApi(franchiseID);
        },
        initPayApi: function (franchiseID) {
            Vue.prototype.$PayApi = new SnapnPayApi(franchiseID);
        },
        clearComputed: function () {
            localStorage.clear();
            this.$isLoggedIn = null;
            this.$franchiseID = null;
            this.$franchiseName = null;
            this.$franchiseUrlFriendlyOrderName = null;
            this.$franchiseLogoUrl = null;
            this.$franchiseBannerUrl = null;
            this.$franchiseAccentColor = null;
            this.$lastSessionDate = null;
            this.$branchID = null;
            this.$isTab = null;
            this.$tableNo = null;

        },
        clearPayComputed: function() {
            this.$payFID = null;
            this.$payBID = null;
            this.$payInvNo = null;
        }
    }
});
// Begin: OnlineOrderingApi 
import { OnlineOrderingApiClientBase } from '@/vendors/platinum/OnlineOrderingApiClientBase.js';
Vue.prototype.$ooApi = new OnlineOrderingApi(localStorage.franchiseID);
Vue.prototype.$ooApi.OnErrorOccured(function (sender, event) {
    if (event.message == sender.errorMessages.invalidRefreshToken) {
        localStorage.removeItem('userMembershipID');
        localStorage.removeItem('userToken');
        localStorage.removeItem('OrdersUserToken');
        localStorage.removeItem('OrdersUserRefreshToken');
        window.location.href = window.location.origin + '/login';
        VueApp.$showErrorToaster('User credentials failed.');
    }
    else if (event.message == sender.errorMessages.failedToFetch) {
        VueApp.$showErrorToaster('Failed to complete request.');
    }
    else
        VueApp.$showErrorToaster(event.message);
});

function OnlineOrderingApi(franchiseID) {
    try {
        OnlineOrderingApiClientBase.call(this, window.config.ApiUrl, null, null, franchiseID);
    }
    catch (error) { //TODO: Redirect to a 'Something went wrong page' 
        alert('Something went wrong in the API client.');
        console.log(error);
    }
}
// End: OnlineOrderingApi 

// Begin: SnapnPayApi 
import { PayApiClientBase } from '@/vendors/platinum/PayApiClientBase.js';
Vue.prototype.$payApi = new SnapnPayApi(localStorage.franchiseID);
Vue.prototype.$payApi.OnErrorOccured(function (sender, event) {
    if (event.message == sender.errorMessages.invalidRefreshToken) {
        localStorage.removeItem('userMembershipID');
        localStorage.removeItem('userToken');
        localStorage.removeItem('OrdersUserToken');
        localStorage.removeItem('OrdersUserRefreshToken');
        window.location.href = window.location.origin + '/login';
        VueApp.$showErrorToaster('User credentials failed.');
    }
    else if (event.message == sender.errorMessages.failedToFetch) {
        VueApp.$showErrorToaster('Failed to complete request.');
    }
    else
        VueApp.$showErrorToaster(event.message);
});

function SnapnPayApi(franchiseID) {
    try {
        PayApiClientBase.call(this, window.config.ApiUrl, null, null, franchiseID)
    }
    catch (error) { //TODO: Redirect to a 'Something went wrong page' 
        alert('Something went wrong in the Payment API client.');
        console.log(error);
    }
}
// End: SnapnPayApi 

var VueApp = new Vue({
    router,
    render: h => h(App)
}).$mount('#app')